import { lazy } from "react";
import withLazyLoading from "../shared/withLazyLoading";
import WatchCardLoading from "./WatchCardLoading";
import CardStatus from "../../component-library/CardMeta/CardStatus";
import CardBadge from "../../component-library/CardBadge/CardBadge";

// Configure with custom options for video loading
const options = {
  rootMargin: "200px 0px",
  threshold: 0
};

// Use Vite's dynamic import syntax
const LazyComponent = lazy(() =>
  import("./WatchCard").then((module) => ({
    default: module.default
  }))
);

const LazyWatchCard = withLazyLoading(LazyComponent, WatchCardLoading, options);

// Add static properties using local imports
LazyWatchCard.Status = CardStatus;
LazyWatchCard.Badge = CardBadge;

export default LazyWatchCard;
